export const PageTypeUtils = {
  commonPrefix: 'legal',
  getPageTypeFromPathname: (pathname: string): string => {
    if (pathname.startsWith('/h5/feoffline/report/safety-')) {
      return `${PageTypeUtils.commonPrefix}-safety`;
    }

    if (pathname.startsWith('/h5/feoffline/report/')) {
      return `${PageTypeUtils.commonPrefix}-infringement`;
    }

    if (pathname.startsWith('/h5/email/unsubscribe')) {
      return `${PageTypeUtils.commonPrefix}-email-unsubscribe`;
    }

    // rest is policy
    const list = pathname.split('/');

    return `${PageTypeUtils.commonPrefix}-${list[list.length - 1]}`;
  },
};
